// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/loyalty/common.proto" (package "bianka.event.activity.v2.extension.loyalty", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.loyalty.Component
 */
export interface Component {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.ComponentType type = 2
     */
    type: ComponentType;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitComponent
 */
export interface LoyaltyBenefitComponent {
    /**
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitName name = 1
     */
    name: LoyaltyBenefitName;
    /**
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.ComponentType type = 2
     */
    type: ComponentType;
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.loyalty.TierLevel
 */
export enum TierLevel {
    /**
     * @generated from protobuf enum value: TIER_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TIER_LEVEL_SILVER = 1;
     */
    SILVER = 1,
    /**
     * @generated from protobuf enum value: TIER_LEVEL_GOLD = 2;
     */
    GOLD = 2,
    /**
     * @generated from protobuf enum value: TIER_LEVEL_PLATINUM = 3;
     */
    PLATINUM = 3,
    /**
     * @generated from protobuf enum value: TIER_LEVEL_DIAMOND = 4;
     */
    DIAMOND = 4
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.loyalty.ComponentType
 */
export enum ComponentType {
    /**
     * @generated from protobuf enum value: COMPONENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: COMPONENT_TYPE_BUTTON = 1;
     */
    BUTTON = 1,
    /**
     * @generated from protobuf enum value: COMPONENT_TYPE_MODAL = 2;
     */
    MODAL = 2,
    /**
     * @generated from protobuf enum value: COMPONENT_TYPE_ALERT_BADGE = 3;
     */
    ALERT_BADGE = 3
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitName
 */
export enum LoyaltyBenefitName {
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_CREDITS_FROM_FIRST_ELIGIBLE_ORDER = 1;
     */
    CREDITS_FROM_FIRST_ELIGIBLE_ORDER = 1,
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_MATCHING_SERVICE = 2;
     */
    MATCHING_SERVICE = 2,
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_PROJECT_PLANNING = 3;
     */
    PROJECT_PLANNING = 3,
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_CREDIT_FROM_DEPOSIT = 4;
     */
    CREDIT_FROM_DEPOSIT = 4,
    /**
     * @generated from protobuf enum value: LOYALTY_BENEFIT_NAME_CONSULTATION = 5;
     */
    CONSULTATION = 5
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.loyalty.ElementName
 */
export enum ElementName {
    /**
     * @generated from protobuf enum value: ELEMENT_NAME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ELEMENT_NAME_AVATAR_MENU = 1;
     */
    AVATAR_MENU = 1,
    /**
     * @generated from protobuf enum value: ELEMENT_NAME_SIDE_BAR = 2;
     */
    SIDE_BAR = 2,
    /**
     * @generated from protobuf enum value: ELEMENT_NAME_LIHP_TOP_BAR = 3;
     */
    LIHP_TOP_BAR = 3
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.loyalty.EventSource
 */
export enum EventSource {
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_TIER_LEVEL_UPDATED_MODAL = 1;
     */
    TIER_LEVEL_UPDATED_MODAL = 1,
    /**
     * @deprecated
     * @generated from protobuf enum value: EVENT_SOURCE_LOYALTY_PAGE_SHOWN = 2 [deprecated = true];
     */
    LOYALTY_PAGE_SHOWN = 2,
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_ALL_ORDERS_BUTTON_CLICKED = 3;
     */
    ALL_ORDERS_BUTTON_CLICKED = 3,
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_ALL_ACTIONS_BUTTON_CLICKED = 4;
     */
    ALL_ACTIONS_BUTTON_CLICKED = 4,
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_LOYALTY_BENEFIT_BAR_CLICKED = 5;
     */
    LOYALTY_BENEFIT_BAR_CLICKED = 5,
    /**
     * @deprecated
     * @generated from protobuf enum value: EVENT_SOURCE_LOYALTY_TIER_ALERT_VIEWED = 6 [deprecated = true];
     */
    LOYALTY_TIER_ALERT_VIEWED = 6,
    /**
     * @generated from protobuf enum value: EVENT_SOURCE_LOYALTY_PAGE = 7;
     */
    LOYALTY_PAGE = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class Component$Type extends MessageType<Component> {
    constructor() {
        super("bianka.event.activity.v2.extension.loyalty.Component", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.event.activity.v2.extension.loyalty.ComponentType", ComponentType, "COMPONENT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<Component>): Component {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<Component>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Component): Component {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bianka.event.activity.v2.extension.loyalty.ComponentType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Component, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bianka.event.activity.v2.extension.loyalty.ComponentType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.loyalty.Component
 */
export const Component = new Component$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoyaltyBenefitComponent$Type extends MessageType<LoyaltyBenefitComponent> {
    constructor() {
        super("bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitComponent", [
            { no: 1, name: "name", kind: "enum", T: () => ["bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitName", LoyaltyBenefitName, "LOYALTY_BENEFIT_NAME_"] },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.event.activity.v2.extension.loyalty.ComponentType", ComponentType, "COMPONENT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<LoyaltyBenefitComponent>): LoyaltyBenefitComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = 0;
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<LoyaltyBenefitComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoyaltyBenefitComponent): LoyaltyBenefitComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitName name */ 1:
                    message.name = reader.int32();
                    break;
                case /* bianka.event.activity.v2.extension.loyalty.ComponentType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoyaltyBenefitComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitName name = 1; */
        if (message.name !== 0)
            writer.tag(1, WireType.Varint).int32(message.name);
        /* bianka.event.activity.v2.extension.loyalty.ComponentType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.loyalty.LoyaltyBenefitComponent
 */
export const LoyaltyBenefitComponent = new LoyaltyBenefitComponent$Type();
